<template lang="pug">
//- .fixed.inset-0.w-0.h-0(:class="'!z-[40]'" uc-word-skip="" v-if="hasAudio")
//- expose these strings for the translate script
//- text="Unmute all"
//- text="Mute all"
//- text="Generating AI audio"
button.bg-white.btn-icon.max-w-none.p-0.hover_bg-gray-100.ripple.ripple--centered.inline-flex.items-center.justify-center.rounded-full.focus-visible_ring-8(
  :aria-label="isJitSynthesizing ? hasTranslation('Generating AI audio') : hasTranslation(suspend.mute ? 'Unmute all' : 'Mute all')"
  :title="isJitSynthesizing ? hasTranslation('Generating AI audio') : hasTranslation(suspend.mute ? 'Unmute all' : 'Mute all')"
  :class="'h-[2.75rem] w-[2.75rem] !z-[40] p-[0.125rem] ripple_bg-primary-500/20'"
  @click="toggleMute"
  ref="buttonRef"
  uc-word-skip=""
  :data-sfx="suspend.mute ? 'sound-on' : 'sound-off'"
  v-if="hasAudio || hasSpeech || hasVideo || hasSfx || hasVoicemail"
)
  transition-grow(:duration="0.3")
    uc-icon.absolute.text-2xl.uc-jit-pulse(icon="mdi:creation" v-if="isJitSynthesizing")
  transition-grow(:duration="0.3")
    uc-icon.absolute.text-2xl(icon="theme:audio-off" v-if="suspend.mute && !isJitSynthesizing")
  transition-grow(:duration="0.3")
    uc-icon.absolute.text-2xl(icon="theme:audio-on" v-if="!suspend.mute && !isJitSynthesizing")
  uc-preload-sfx(name="sound-on")
  uc-preload-sfx(name="sound-off")
</template>

<script setup lang="ts">
import useSuspend from '../lib/useSuspend';
import { muteAll, unmuteAll } from '../lib/audio';
import { isJitSynthesizing } from '../lib/jitSynthesisActive';
import { computed, inject, ref } from 'vue';
import { onKeyUp } from '@vueuse/core';
import isUserTyping from '../lib/isUserTyping';
import { storeToRefs } from 'pinia';
import useEditMode from '../stores/useEditMode';
import useTranslations from '../stores/useTranslations';

const { available } = storeToRefs(useEditMode());
const isEditMode = computed(() => available.value);
const buttonRef = ref<HTMLElement | null>(null);
const suspend = useSuspend();
const hasAudio = inject('hasAudio');
const hasSpeech = inject('hasSpeech');
const hasVideo = inject('hasVideo');
const hasSfx = inject('hasSfx');
const hasVoicemail = inject('hasVoicemail');
const { translations } = useTranslations();

const toggleMute = () => {
  suspend.mute ? unmuteAll() : muteAll();
};

/**
 * Press `m` to toggle mute, focus mute button
 */
onKeyUp('m', () => {
  if (isUserTyping() || isEditMode.value) {
    return;
  }

  toggleMute();
});

const hasTranslation = (key, fallback) => {
  // get the translation if it exists
  let maybeTranslated =
    translations?.[suspend.locale]?.[key] ||
    translations?.[suspend.locale]?.[fallback];

  return maybeTranslated || key;
};
</script>

<style scoped>
.uc-jit-pulse {
  animation: uc-jit-pulse 1.4s ease-in-out infinite;
}

@keyframes uc-jit-pulse {
  0%,
  100% {
    opacity: 0.55;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.06);
  }
}

@media (prefers-reduced-motion: reduce) {
  .uc-jit-pulse {
    animation: none;
    opacity: 1;
  }
}
</style>
